import React from 'react'

import PrecautionModal from 'src/components/Modal/PrecautionModalPlan'

const PrecautionModalPage: React.FC = () => {
  return <PrecautionModal isOpen={true} />
}

export const PATH = '/precaution-modal-plan' as const
export default PrecautionModalPage
